import { render, staticRenderFns } from "./PaperPlane.vue?vue&type=template&id=9adeb540"
import script from "./PaperPlane.vue?vue&type=script&lang=js"
export * from "./PaperPlane.vue?vue&type=script&lang=js"
import style0 from "./PaperPlane.vue?vue&type=style&index=0&id=9adeb540&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports